/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { useContext } from 'react'

import { ModalV2Context } from './modal-v2.context'

export const useModalV2Context = () => useContext(ModalV2Context)
